<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Hugs'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Hugs'
        };
    },

    computed: {
        labels() {
            return [
                { value: 'name', width: '150px' },
                {
                    value: 'number',
                    width: '150px'
                },
                { value: 'year', width: '150px' },
                { text: 'English name', value: 'nameEng', width: '150px' },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'hugs/index',
            deleteItem: 'hugs/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/hugs/${id}/edit`);
        },
        onAddButtonClick() {
            this.$router.push('/hugs/add');
        }
    }
};
</script>
